var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DRAFT_LOADER, UPDATE_DELTED_DRAFT_DOCS, UPDATE_DRAFT_ORDER_DECLARATIONS, UPDATE_PREVIEW_DOCS, UPDATE_SAVE_DRAFT_DOCS, UPDATE_SAVE_DRAFT_ORDERS, } from "../interface";
var initialState = {
    previewDocs: null,
    draftOrderDeclarations: null,
    saveDarftDocs: null,
    deletedDraftDocs: null,
    saveDraftOrders: null,
    draftLoader: false,
};
var draftReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case UPDATE_PREVIEW_DOCS:
            return __assign(__assign({}, state), { previewDocs: action.payload.previewDocs });
        case UPDATE_SAVE_DRAFT_DOCS:
            return __assign(__assign({}, state), { saveDarftDocs: action.payload.saveDarftDocs });
        case UPDATE_DRAFT_ORDER_DECLARATIONS:
            return __assign(__assign({}, state), { draftOrderDeclarations: action.payload.draftOrderDeclarations });
        case UPDATE_SAVE_DRAFT_ORDERS:
            return __assign(__assign({}, state), { saveDraftOrders: action.payload.saveDraftOrders });
        case UPDATE_DELTED_DRAFT_DOCS:
            return __assign(__assign({}, state), { deletedDraftDocs: action.payload.deletedDraftDocs });
        case DRAFT_LOADER:
            return __assign(__assign({}, state), { draftLoader: action.payload.draftLoader });
        default:
            return state;
    }
};
export default draftReducer;
